import * as React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { useMemo } from "react";
import { styled } from "styled-components";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import PrintingWidgetVisualization from "report/common/PrintingWidgetVisualization";
import searchTypeDefinition from "views/logic/SearchType";
export const Container = styled.div`
  width: 100%;
  height: calc(100% - 50px);

  .quickvalues-table {
    margin: 0 auto;
    text-align: left;
    width: 80%;
  }

  .dc-chart {
    float: none;
  }

  @media print {
    /* This is the desired behaviour, but currently unimplemented in Chrome. It may be implemented in a future version, so we leave it here. */
    break-after: avoid;
    break-before: avoid;
    break-after: avoid;
    break-before: avoid;
    margin-bottom: 4rem;
  }
`;
const _searchTypePlugin = (type) => {
  const typeDefinition = searchTypeDefinition(type);
  return typeDefinition && typeDefinition.handler ? searchTypeDefinition(type).handler : {
    convert: (result) => {
      console.error(`No search type handler for type '${type}' result:`, result);
      return result;
    }
  };
};
const PrintingWidgetVisualizationContainer = ({
  visualizationHeight,
  interactive,
  limitHeight,
  value,
  widget,
  widgetId,
  width
}) => {
  const fieldTypes = useMemo(
    () => ({
      all: value.types,
      currentQuery: value.types
    }),
    [value.types]
  );
  const mappedResult = useMemo(() => {
    const mappedResults = value.result.filter((res) => !!res).map((searchType) => _searchTypePlugin(searchType.type).convert(searchType));
    const widgetPlugin = PluginStore.exports("enterpriseWidgets").find(
      (w) => w.type.toUpperCase() === widget.type.toUpperCase()
    );
    const { searchResultTransformer = (x) => x } = widgetPlugin || {};
    return searchResultTransformer(mappedResults);
  }, [value.result, widget.type]);
  return /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: fieldTypes }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    PrintingWidgetVisualization,
    {
      widget,
      widgetId,
      result: mappedResult,
      hasError: value.hasError,
      errorMessage: value.errorMessage,
      types: value.types,
      visualizationHeight,
      width,
      interactive,
      limitHeight
    }
  )));
};
export default PrintingWidgetVisualizationContainer;
